import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=ff28667c&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style1 from "./edit.vue?vue&type=style&index=1&id=ff28667c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff28667c",
  null
  
)

export default component.exports